/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

//window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


document.addEventListener('DOMContentLoaded', () => {
    require('./modules/helpers')
    require('./modules/fingerprint2')
    require('./modules/cookies')
    require('./modules/modals')
    require('./modules/geolocation')
    require('./modules/emails')
    require('./modules/rates')
    require('./modules/comments')
    require('./modules/sliders')
    require('./modules/video')
    require('./modules/filters')
    require('./modules/food-filters')
    require('./modules/ckeditor')
    require('./modules/draggable_sort')
    require('./modules/dropzone')
    require('./modules/tabs')
    require('./modules/scrolls')
})
